export const primaryColor = '#304DB9';
export const primaryColorBg = '#304DB91a';

export const dangerColor = '#F5222D';
export const dangerColorBg = '#F5222D1A';

export const borderColor = '#e5e6eb';

export const tableHeaderBg = '#F0F0F0';

export const grayBackgroundColor = '#F9F9F9';

export const iconColor = '#6b7785';
